import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";

import styles from "./SupportArticle.module.css";
import Header from "../../../common/components/Header";
import LinkBtn from "Page/common/components/LinkBtn";
import FileList from "Page/common/components/FileList";

export default function SupportArticle() {
  const location = useLocation();
  const { category_id } = location.state;
  const { article_id } = useParams();
  let [data, setData] = useState({ title: "", uploaded_at: "" });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/support/article/${article_id}`)
      .then((res) => {
        if (res.data.length !== 0) {
          let newData = res.data[0];
          setData(newData);
        }
      });
  }, []);

  return (
    <div className={styles.SupportArticle}>
      <Header title={category_id == 1 ? "공지사항" : "자료실"} />
      <div className={styles.Article}>
        <div className={styles.TitleDiv}>
          <div className={styles.Title}>{data.title}</div>
          <div className={styles.Date}>{data.uploaded_at.slice(0, 10)}</div>
        </div>
        <FileList api="support" article_id={article_id} />
        <div className={styles.Content}>{data.content}</div>
      </div>
      <LinkBtn to={`/support/category/${category_id}`} title="목록" />;
    </div>
  );
}
